import {
    TablePage,
    AddPage,
    EditPage,
    ViewPage,
  } from 'src/views/aciair/s10'
  import pathMap from 'src/paths/pathMap'
  
  class AciAirRoute {
    getConfigurations() {
      return [
        {
          exact: true,
          path: pathMap.ACI_AIR_S10_LIST_VIEW,
          component: TablePage
        },
        {
          exact: true,
          path: pathMap.ACI_AIR_S10_ADD_VIEW,
          component: AddPage
        },
        {
          exact: true,
          path: pathMap.ACI_AIR_S10_EDIT_VIEW,
          component: EditPage
        },
        {
          exact: true,
          path: pathMap.ACI_AIR_S10_DETAILS_VIEW,
          component: ViewPage
        }
      ]
    }
  }
  
  export default AciAirRoute
  